import { render, staticRenderFns } from "./sw.vue?vue&type=template&id=372600ef&scoped=true"
import script from "./sw.vue?vue&type=script&lang=js"
export * from "./sw.vue?vue&type=script&lang=js"
import style0 from "./sw.vue?vue&type=style&index=0&id=372600ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372600ef",
  null
  
)

export default component.exports